// extracted by mini-css-extract-plugin
export default {"avatar":"AvatarUsuario_avatar__Q9nv8"};